import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'pixl-card2',
  imports: [
    MatCardModule
  ],
  templateUrl: './card2.component.html',
  styleUrl: './card2.component.scss'
})
export class Card2Component {

}
